import { render } from "./ExportClientsModal.vue?vue&type=template&id=2b5a126f"
import script from "./ExportClientsModal.vue?vue&type=script&lang=js"
export * from "./ExportClientsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__